const QuizQuestions = [
    {
        id: 1,
        title: "ReactJS",
        quiz: [
            {
                question: "What is React.js?",
                options: [
                    "A JavaScript framework for building user interfaces.",
                    "A server-side programming language.",
                    "A database management system.",
                    "A front-end CSS framework."
                ],
                answer: "A JavaScript framework for building user interfaces."
            },
            {
                question: "What does JSX stand for?",
                options: [
                    "Java Syntax Extension",
                    "JSON Xchange Schema",
                    "JavaScript XML",
                    "JavaScript Xerography"
                ],
                answer: "JavaScript XML"
            },
            {
                question: "Which lifecycle method is invoked immediately after a component is rendered on the DOM?",
                options: [
                    "componentDidMount",
                    "componentDidUpdate",
                    "componentWillMount",
                    "componentWillRender"
                ],
                answer: "componentDidMount"
            },
            {
                question: `What is the purpose of the "key" prop in React?`,
                options: [
                    "It determines the visual styling of a component.",
                    "It specifies the route for navigation within a React application.",
                    "It uniquely identifies a component in an array of components.",
                    "It defines the data type of a component's prop. "
                ],
                answer: "It uniquely identifies a component in an array of components."
            },
            {
                question: "What is the state of React class component?",
                options: [
                    "A JavaScript method for sorting arrays.",
                    "A built-in object that stores component data.",
                    "A CSS class used for component styling.",
                    "A React component's initial render method."
                ],
                answer: "A built-in object that stores component data."
            },
            // {
            //     question: "",
            //     options: [
            //         "",
            //         "",
            //         "",
            //         ""
            //     ],
            //     answer: ""
            // },
            // {
            //     question: "",
            //     options: [
            //         "",
            //         "",
            //         "",
            //         ""
            //     ],
            //     answer: ""
            // },
            // {
            //     question: "",
            //     options: [
            //         "",
            //         "",
            //         "",
            //         ""
            //     ],
            //     answer: ""
            // },
            // {
            //     question: "",
            //     options: [
            //         "",
            //         "",
            //         "",
            //         ""
            //     ],
            //     answer: ""
            // },
        ]
    }
]

export default QuizQuestions;